import React from "react"
import ReactDOM from "react-dom"
import SpotButtonSlider from "./spot-button-slider"
import SpotButton from "../spot-button/spot-button"

export default class SpotButtonSliderModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.data = JSON.parse(elem.dataset.model)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.render(
      <SpotButtonSlider>
        {self.data.Elements.map((element, index) => (
          <div key={index}>
            <SpotButton {...element} />
          </div>
        ))}
      </SpotButtonSlider>,
      self.elem,
    )
  }
}
